module.exports = __webpack_public_path__ + "images/arc_small77b99ba7485c28919f87dc428e72b071.png";